import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';

export default function ClientSection(props) {
  const { ctx, res, profile, classes, link } = props;
  const readOnly = !ctx.state.editForm;

  const blockAndAlert = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof ctx?.alertReadOnly === 'function') ctx.alertReadOnly();
  };

  const Shield = readOnly ? (
    <div
      style={{ position: 'absolute', inset: 0, zIndex: 2 }}
      tabIndex={-1}
      aria-hidden="true"
      onMouseDown={blockAndAlert}
    />
  ) : null;

  return (
    <div style={{ display: ctx.state.tabValue === 0 ? 'flex' : 'none', flexDirection: ctx.state.tabValue === 0 ? 'column' : '', marginTop: '1rem' }}>
      <h2 style={{ margin: '0' }}>{res.CLIENTE}</h2>

      <div style={{ position: 'relative', width: '100%' }}>
        {Shield}
        <FormControl style={{ width: '100%' }}>
          <InputLabel>{res.CLIENTE}</InputLabel>
          <Select
            id="client"
            value={ctx.state.client || ''}
            onChange={ctx.handleClientChange}
            inputProps={{ tabIndex: readOnly ? -1 : 0, 'aria-readonly': readOnly }}
            endAdornment={
              ctx.state.client ? (
                <IconButton
                  size="small"
                  style={{ marginRight: 24 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    ctx.handleClientChange({ target: { value: '' } });
                  }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              ) : null
            }
          >
            {ctx.state.clients.map((client) => (
              <MenuItem key={client.id} value={client.name}>
                {client.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div style={{ display: 'flex' }}>
        <TextField
          id="responsible"
          label={res.RESPONSAVEL}
          value={ctx.state.responsible || ''}
          onChange={ctx.handleChange('responsible')}
          margin="normal"
          fullWidth
          onInput={(e) => { e.target.value = e.target.value.toString().slice(0, 45); }}
          style={{ marginRight: '1rem' }}
          InputProps={{ readOnly }}
          onMouseDown={readOnly ? blockAndAlert : undefined}
        />
        <TextField
          id="contact"
          label={res.CONTATO}
          value={ctx.state.contact}
          onChange={ctx.handleChange('contact')}
          margin="normal"
          fullWidth
          onInput={(e) => { e.target.value = e.target.value.toString().slice(0, 45); }}
          style={{ marginLeft: '1rem' }}
          InputProps={{ readOnly }}
          onMouseDown={readOnly ? blockAndAlert : undefined}
        />
      </div>

      <div style={{ display: 'flex' }}>
        {!ctx.state.idClient ? (
          <TextField
            id="property"
            label={res.PROPRIEDADE}
            value={ctx.state.property}
            onChange={ctx.handleChange('property')}
            margin="normal"
            fullWidth
            onInput={(e) => { e.target.value = e.target.value.toString().slice(0, 45); }}
            style={{ marginRight: '1rem' }}
            InputProps={{ readOnly }}
            onMouseDown={readOnly ? blockAndAlert : undefined}
          />
        ) : (
          <div style={{ position: 'relative', width: '100%', marginRight: '1rem' }}>
            {Shield}

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: '1rem',
                marginBottom: '0.15rem'
              }}
            >
              <span
                style={{
                  fontSize: '0.75rem',
                  color: 'rgba(0, 0, 0, 0.6)'
                }}
              >
                {res.PROPRIEDADE}
              </span>

              {!readOnly && (
                <Button
                  color="primary"
                  size="small"
                  onClick={ctx.openPropertyModal}
                  style={{
                    minWidth: 'unset',
                    padding: 0,
                    textTransform: 'none',
                    fontSize: '0.75rem',
                    fontWeight: 500
                  }}
                >
                  <AddIcon style={{ fontSize: 16, marginRight: 4 }} />
                  {res.NOVA_PROPRIEDADE}
                </Button>
              )}
            </div>

            <FormControl style={{ width: '100%' }}>
              <Select
                id="property"
                value={ctx.state.property || ''}
                onChange={ctx.handlePropertyChange}
                displayEmpty
                inputProps={{ tabIndex: readOnly ? -1 : 0, 'aria-readonly': readOnly }}
                endAdornment={
                  ctx.state.property ? (
                    <IconButton
                      size="small"
                      style={{ marginRight: 24 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        ctx.handlePropertyChange({ target: { value: '' } });
                      }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  ) : null
                }
                renderValue={(selected) => selected || ''}
              >
                {ctx.state.properties.map((property) => (
                  <MenuItem key={property.id} value={property.name}>
                    {property.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}

        <TextField
          id="address"
          label={res.ENDERECO}
          value={ctx.state.address}
          onChange={ctx.handleChange('address')}
          margin="normal"
          fullWidth
          onInput={(e) => { e.target.value = e.target.value.toString().slice(0, 45); }}
          style={{ marginLeft: '1rem' }}
          InputProps={{ readOnly }}
          onMouseDown={readOnly ? blockAndAlert : undefined}
        />
      </div>

      <TextField
        id="obs"
        label={res.OBSERVACOES}
        value={ctx.state.obs}
        onChange={ctx.handleChange('obs')}
        margin="normal"
        fullWidth
        multiline
        rows={4}
        onInput={(e) => { e.target.value = e.target.value.toString().slice(0, 200); }}
        InputProps={{ readOnly }}
        onMouseDown={readOnly ? blockAndAlert : undefined}
      />

    </div>
  );
}